<template>
<el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>设备编号：</label>
                    <el-input v-model="search_Obj.f_device_code" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>设备类型：</label>
                    <el-select v-model="search_Obj.f_device_type" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('device_type4')" :key="'device_type4'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <div class="searchGroup">
                    <label>是否巡检：</label>
                    <el-select v-model="search_Obj.f_is_check" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column prop="top_pid" label="所在工程" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.top_pid, "project_group") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="device_code" label="设备编号" sortable="custom"></el-table-column>
                    <el-table-column prop="device_type" label="设备类型" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.device_type, "device_type4") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="day" label="日期" sortable="custom"></el-table-column>
                    <el-table-column prop="is_check" label="是否巡检" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.is_check, "yesNo") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="answers_str" label="巡检结果" sortable="custom"></el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" plain type="primary" @click="info(1, scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
            <Info
                width="600px"
                :id="model_id"
                title="查看设备巡检记录"
                :isshow="infoshow"
                @on-close="closeInfoDialog">
            </Info>
        </div>
    </el-dialog>
</template>

<script>
import Info from "./info1"
import listutil from "@/libs/listutil"

export default {
    name: 'deviceInspectionLogList',
    mixins: [listutil],
    components: {Info},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        report_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_report_id = this.report_id;
            this.search_Obj.f_device_type = ''
            this.search_Obj.f_device_code = ''
            this.search_Obj.f_is_check = ''
            this.getData()
        },
    },
    data() {
        return {
            m_name: '设备巡检记录',
            menu_id: 3600,
            list_url: "/api/admin/deviceinspectionlog/list1",
            search_Obj: {
                f_report_id: '',
                f_device_type: '',
                f_device_code: '',
                f_is_check: '',
            },
            del_Obj:{
                url:'/api/admin/deviceinspectionlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['device_type4', 'project_group', 'yesNo'],
            showflag: false,
            pagesize: 10,
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
    }
};
</script>